module.exports = require('./lib/chai');



//////////////////
// WEBPACK FOOTER
// ./~/chai/index.js
// module id = 26
// module chunks = 1 3